<template lang="pug">
  .course-report-wrap
    .course-report-grid
      .course(v-for='program in programList'
              :key='program.id'
      )
        .course-title {{ program.title }}
        .course-status
          icon(v-if='program.failed' name='times-circle' color='darkred' :scale='1.3')
          icon(v-if='program.passed' name='check-circle' color='green' :scale='1.3')
          icon(v-if='program.inProgress' name='clock' color='orange' :scale='1.3')
          icon(v-if='program.pending' name='minus' color='#ddd' :scale='1.3')

</template>

<script>
export default {
  props: ["programList"],
  methods: {}
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/_mixins.scss";

.course-report-wrap {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  align-items: flex-start;
  background: white;
}

.course-report-grid {
  padding: 20px;
  width: 70%;
  display: flex;
  flex-wrap: wrap;

  .course {
    width: calc(100% / 5 - 5px);
    display: flex;
    flex-direction: column;
    margin: 5px;
    &.active {
      .course-title {
        background: #8b8b8b;
      }
      .course-status {
        background: #e7e7e7;
        border: none;
      }
    }
    .course-title {
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      @include heading_font();
      height: 100px;
      background: #afafaf;
    }
    .course-status {
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e7e7e7;
    }
  }
}

.course-details {
  border-left: 2px solid #f4f5f7;

  padding: 20px;
  align-self: stretch;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  .course-title {
    @include heading_font($fs: 17px);
    margin: 0 0 10px 0;
  }
  p {
    margin: 0 0 10px 0;
  }
  .status {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 40px;
    .fa-icon {
      margin: 0 10px 0 0;
    }
    p {
      margin: 0;
    }
  }
}
</style>
